export default "__VITE_ASSET__AAEV$kk2__"